import { breakpoints } from 'style'
import styled from 'styled-components'

export const GetStartedContainer = styled.div`
  @media (max-width: ${breakpoints.sm}px) {
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
